import {HttpService} from "./HttpService";
import axios from "axios";
import {FieldDTOBase, FormV4Api} from "@jnext/ts-axios-coreuser";
import {FieldDTO} from "@jnext/ts-axios-coreuser/models/field-dto";
import {ConsumerV4Api} from "@jnext/ts-axios-coreuser/dist/apis/consumer-v4-api";
import {ConsumerDto, FieldDtoBaseRequest} from "@jnext/ts-axios-coreuser/models";

export class FormService {

    static async getFinalizationExtraProfile(): Promise<FieldDTO[]> {
        // @ts-ignore
        const instance = new FormV4Api(undefined, HttpService.servicePath('core-user'), axios);
        const res = await instance.getFinalizationExtraProfile();
        return res?.data?.fields ?? [];
    }

    static async updateExtraUserFirstLevel(fieldDtoBaseRequest: FieldDTOBase[]): Promise<ConsumerDto> {
        // @ts-ignore
        const instance = new ConsumerV4Api(undefined, HttpService.servicePath('core-user'), axios);
        const res = await instance.updateExtraUserFirstLevel({
            fields: fieldDtoBaseRequest
        });
        return res?.data;
    }
}